import "./WellBeingIndex.css";
import Selector from "../components/Selector"
import { useState } from "react";
import MyForm from "../components/Form";
import FiltersResult from "../components/FiltersResult";

import FetchYearDropdown from "../components/FetchYearsDropdown"
import FetchDemographicsDropdown from "../components/FetchDemographicsDropdown"
import FetchParametersOfMovement from "../components/FetchParametersOfMovement";
import IndicatorTable from "../components/IndicatorTable"


function WellBeingIndex(){

    const [yearSelector, setyearSelector] = useState("")
    const [DemographicsSelector, setDemographicsSelector] = useState("")
    const [parametersOfMovement, setparametersOfMovement] = useState("")
    const [selectedCategoryState, setselectedCategoryState] = useState("")

    const SelectorOptions = {
        title: "",
        defaultText: "Επιλέξτε κατηγορία",
        options: [{value: "Παράμετροι Κινητικότητας", label: "Παράμετροι Κινητικότητας"}, {value: "Δημογραφικά Χαρακτηριστικά", label: "Δημογραφικά Χαρακτηριστικά"}]
    }


    // console.log("Year Dropdown", yearSelector)
    // console.log("Demographics Dropdown", DemographicsSelector)
    // console.log("Movement Dropdown", parametersOfMovement)
    // console.log("selectedCategoryState",selectedCategoryState)
    
    return(
        <div>
        <div className="container wrapper">
            <div>
                <h2>Μεθολογία Έρευνας</h2>
                <p> Το ερωτηματολόγιο που χρησιμοποιήθηκε για τις ανάγκες της έρευνας ερωτηματολογίου αναπτύχθηκε μετά από ανασκόπηση της διεθνούς βιβλιογραφίας προσαρμοσμένο στις ανάγκες του έργου και στις ιδιαίτερες συνθήκες που καθορίστηκαν από τις υγειονομικές συνθήκες λόγω της πανδημίας Covid-19. </p>
                
                <p>Η ερευνητική ομάδα του Τμήματος Αγρονόμων & Τοπογράφων Μηχανικών, Α.Π.Θ. συμβουλεύτηκε την Επιτροπή Ισότητας των Φύλων του Α.Π.Θ. σε θέματα διατύπωσης συγκεκριμένων ερωτημάτων.
                Το ερωτηματολόγιο που αναπτύχθηκε και χρησιμοποιήθηκε συντίθεται από δύο (2) ομάδες ερωτήσεων. Προηγείται αυτών εισαγωγικό και επεξηγηματικό κείμενο αναφορικά με το αντικείμενο της έρευνας καθώς επίσης τον Γενικό Κανονισμό Προστασίας Δεδομένων προκειμένου οι συμμετέχουσες/ οντες να λάβουν γνώση και εφόσον το επιθυμούν να συναινέσουν στη συμμετοχή τους στην έρευνα.</p>
                {/* <a href= "https://drive.google.com/file/d/1hg_KcTZKItkaiK2W3av3NZ7yLZA_4kOy/view" > */}
                    <button className = "ServiceButton" onClick={() => window.open('https://drive.google.com/file/d/1hg_KcTZKItkaiK2W3av3NZ7yLZA_4kOy/view', '_blank')}> Πήγαινε στο link</button>
                {/* </a> */}

                <h2 style = {{marginTop: "7%", marginBottom : "3%"}}> Δεδομένα έρευνας για χαρακτηριστικά μετακινήσεων</h2>
            </div>
            <div style= {{display: "flex"}}>
                <div className="box">
                    1
                </div>

                <h5 style={{marginTop: 15, marginLeft: 10}}>Δεδομένα της έρευνας</h5>
            </div>
            <p> Μάθε για την μεθοδολογία που χρησιμοποιήσαμε για να παρέχουμε τα δεδομένα για τα μέσα μεταφοράς.</p>
            <div style= {{display: "flex"}}>
                <FetchYearDropdown passData = {setyearSelector} resetDemographicsDropdown = {setDemographicsSelector} resetMovementDropdown = {setparametersOfMovement} resetDropdownValue = {setselectedCategoryState}></FetchYearDropdown>
                <Selector props = {SelectorOptions} onSelect = {setselectedCategoryState}></Selector>
                {selectedCategoryState !== "" && yearSelector.length !== 0 ? selectedCategoryState === "Παράμετροι Κινητικότητας" ? <FetchParametersOfMovement passData={setparametersOfMovement} resetDemographicsValue = {setDemographicsSelector}></FetchParametersOfMovement>
                    : <FetchDemographicsDropdown passData={setDemographicsSelector} resetMovementValue = {setparametersOfMovement}></FetchDemographicsDropdown> : <></>
                }
{/*     
                <FetchDemographicsDropdown passData={setDemographicsSelector} disableDemographics = {DisableDemographicsDropdown} disableMovement = {setDisableMovementParametersDropdown} resetMovementValue = {setparametersOfMovement}></FetchDemographicsDropdown>
                <FetchParametersOfMovement passData={setparametersOfMovement} disableDemographics = {setDisableDemographicsDropdown}  disableMovement = {DisableMovementParametersDropdown} resetDemographicsValue = {setDemographicsSelector}></FetchParametersOfMovement> */}
            </div>

            {yearSelector && (DemographicsSelector.length !== 0 || parametersOfMovement.length !== 0)? <FiltersResult year ={yearSelector} demographics = {DemographicsSelector} movement = {parametersOfMovement}></FiltersResult> : <></>}


            <h2 style = {{marginTop: "10%"}}>Υποβολή αιτήματος για την παροχή των πρωτογενών δεδομένων</h2>
            <p>Σε περίπτωση που επιθυμείτε να έχετε πρόσβαση στα πρωτογενή δεδομένα της έρευνας συμπληρώστε τα στοιχεία σας και υποβάλετε το αίτημά σας.</p>
            <p>Σύντομα θα λάβετε απάντηση στο αίτημά σας από το Εργαστήριο Σχεδιασμού Μεταφορών, Συγκοινωνιακής Τεχνικής και Οδοποιίας του Τμήματος Αγρονόμων & Τοπογράφων Μηχανικών της Πολυτεχνικής Σχολής του Α.Π.Θ.</p>
            <MyForm></MyForm>

            <h2 style = {{marginTop: "10%"}}>Υπολογισμός τιμής δείκτη ικανοποίησης</h2>
            <p>Προκειμένου να υπολογισθεί ο δείκτης ικανοποίησης των συμμετεχόντων/ουσών στην έρευνα ερωτηματολογίου, χρησιμοποιήθηκε εργαλείο που διατίθεται στην ιστοσελίδα της Ευρωπαϊκής Επιτροπής και το οποίο αναπτύχθηκε στο πλαίσιο τηλεφωνικής έρευνας ερωτηματολογίου που πραγματοποιεί η Ευρωπαϊκή Στατιστική Υπηρεσία (EUROSTAT) σε τακτική βάση. Η πρώτη έρευνα πραγματοποιήθηκε το 2015 με στόχο τον υπολογισμό του επιπέδου διαβίωσης των κατοίκων σε 79 ευρωπαϊκές πόλεις τόσο μελών της Ευρωπαϊκής Ένωσης όσο και της Ισλανδίας, Νορβηγίας, Ελβετίας και Τουρκίας.</p>
            <p>Ο δείκτης ικανοποίησης υπολογίσθηκε για δύο μεταφορικά μέσα (Δημόσιες Συγκοινωνίες και Ι.Χ. επιβατικό αυτοκίνητο).</p>

            <p style={{color : "blue"}}><strong>*Για να υπολογισθεί ο δείκτης ικανοποίησης πρέπει ο αριθμός των δειγμάτων να ισούται με το άθροισμα κάθε γραμμης. </strong></p>
        </div>     
            
            <IndicatorTable></IndicatorTable>
            </div> 

        
                

    )
} 

export default WellBeingIndex;